<div class="p-4">
  <div class="flex justify-end items-end flex-wrap gap-2 mb-4">
    <button 
      nz-button 
      nzType="primary" 
      nzSize="default"
      class="mr-1"
      (click)="addSensorType()">
      <i nz-icon nzType="plus"></i>
      Add Sensor Type
    </button>
    
  </div>

  <nz-table 
    #basicTable 
    [nzData]="sensorTypes" 
    [nzLoading]="isLoading"
    [nzPageSize]="10"
    [nzShowPagination]="true"
    [nzShowSizeChanger]="true"
    [nzShowQuickJumper]="true">
    
    <thead>
      <tr>
        <th *ngFor="let column of listOfColumns">
          {{ column.name }}
        </th>
      </tr>
    </thead>
    
    <tbody>
      <tr *ngFor="let sensorType of basicTable.data; let i = index">
        <td>{{ sensorType.id }}</td>
        <td>{{ sensorType.abbreviation }}</td>
        <td>{{ sensorType.description }}</td>
        <td nzEllipsis="...">
          <span nz-tooltip="Edit" [nzTooltipColor]="'#fff'" nz-icon nzType="edit" nzTheme="outline"
            class="text-base text-primary cursor-pointer"
            (click)="editSensorType(sensorType)"></span>
          <span nz-tooltip="Delete" [nzTooltipColor]="'#fff'" nz-icon nzType="delete" nzTheme="outline"
            class="text-base text-danger cursor-pointer ml-5"
            nz-popconfirm nzPopconfirmPlacement="bottom"
            nzPopconfirmTitle="Are you sure to remove this record?"
            (nzOnConfirm)="deleteSensorType(sensorType.id, true)"></span>
        </td>
      </tr>
    </tbody>
  </nz-table>

  <div *ngIf="sensorTypes.length === 0 && !isLoading" class="text-center py-8">
    <nz-empty nzNotFoundContent="No sensor types found"></nz-empty>
  </div>
</div>

<div *ngIf="isModalVisible" class="modal-overlay" (click)="handleCancel()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>{{ isEditMode ? 'Edit Sensor Type' : 'Add New Sensor Type' }}</h3>
      <button class="close-btn" (click)="handleCancel()">×</button>
    </div>
    <div class="modal-body">
      <div *ngIf="sensorTypeForm">
        <form nz-form [formGroup]="sensorTypeForm" (ngSubmit)="submitForm()">
          <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired>Sensor Type</nz-form-label>
            <nz-form-control [nzSpan]="18" 
              [nzErrorTip]="sensorTypeForm.get('sensorType')?.errors?.['duplicate'] ? 'Sensor type already exists' : sensorTypeForm.get('sensorType')?.errors?.['apiValidation'] ? 'Sensor type validation failed' : 'Please enter sensor type (max 50 characters)'">
              <input 
                nz-input 
                formControlName="sensorType" 
                placeholder="Enter sensor type name"
                maxlength="50"
                (blur)="validateSensorType()" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired>Abbreviation</nz-form-label>
            <nz-form-control [nzSpan]="18" 
              [nzErrorTip]="sensorTypeForm.get('abbreviation')?.errors?.['duplicate'] ? 'Abbreviation already exists' : sensorTypeForm.get('abbreviation')?.errors?.['apiValidation'] ? 'Abbreviation validation failed' : 'Please enter abbreviation (max 3 characters)'">
              <input 
                nz-input 
                formControlName="abbreviation" 
                placeholder="Enter abbreviation (max 3 chars)"
                maxlength="3"
                (blur)="validateAbbreviation()" />
            </nz-form-control>
          </nz-form-item>

          <nz-form-item>
            <nz-form-label [nzSpan]="6" nzRequired>Color Codes</nz-form-label>
            <nz-form-control [nzSpan]="18">
              <div class="color-inputs">
                <div class="color-input-group">
                  <label>Temperature:</label>
                  <input 
                    nz-input 
                    type="color" 
                    formControlName="temperatureColor" 
                    style="width: 80px; height: 32px; margin-left: 8px;" />
                </div>
                <div class="color-input-group">
                  <label>Humidity:</label>
                  <input 
                    nz-input 
                    type="color" 
                    formControlName="humidityColor" 
                    style="width: 80px; height: 32px; margin-left: 8px;" />
                </div>
                <div class="color-input-group">
                  <label>Pressure:</label>
                  <input 
                    nz-input 
                    type="color" 
                    formControlName="pressureColor" 
                    style="width: 80px; height: 32px; margin-left: 8px;" />
                </div>
              </div>
            </nz-form-control>
          </nz-form-item>


          <nz-form-item>
            <nz-form-control [nzOffset]="6" [nzSpan]="18">
              <button 
                nz-button 
                nzType="primary" 
                [nzLoading]="isFormLoading"
                [disabled]="!sensorTypeForm.valid"
                type="submit">
                {{ isEditMode ? 'Update Sensor Type' : 'Add Sensor Type' }}
              </button>
              <button 
                nz-button 
                nzType="default" 
                (click)="handleCancel()"
                style="margin-left: 8px;">
                Cancel
              </button>
            </nz-form-control>
          </nz-form-item>
        </form>
      </div>
      
      <div *ngIf="!sensorTypeForm" class="text-center p-4">
        <nz-spin nzSize="large"></nz-spin>
        <p>Loading form...</p>
      </div>
    </div>
  </div>
</div>
